// ids — утиліти для генерації унікальних ідентифікаторів.


export function newId() {
  return crypto.randomUUID ? crypto.randomUUID() : String(Date.now());
}
